import React from 'react'
import { TextInput, BymaFormCard, LocalErrorAlert } from 'components'
import { Col, Row } from 'react-bootstrap'

export const PaisForm = ({ cardTitle, editEnabled = false }) => {
  return (
    <>
      <BymaFormCard title={cardTitle}>
        <Row sm={12}>
          <Col sm={6}>
            <TextInput
              name='denominacion'
              label='Denominación FCI/SSN'
              required={true}
              readOnly={!editEnabled}
            />
          </Col>

          <Col sm={3}>
            <TextInput name='codigo' label='Código' required={true} readOnly={!editEnabled} />
          </Col>
        </Row>

        <Row sm={12}>
          <Col sm={3}>
            <TextInput name='alfa2' label='Código 2' required={true} readOnly={!editEnabled} />
          </Col>

          <Col sm={3}>
            <TextInput name='alfa3' label='Código 3' required={true} readOnly={!editEnabled} />
          </Col>
        </Row>
      </BymaFormCard>

      <div style={{ marginTop: '1em' }}>
        <LocalErrorAlert />
      </div>
    </>
  )
}
